var defaultTemplates = {
    resetLabel: function resetLabel() {
        return 'Clear refinements';
    }
};

export { defaultTemplates as default };
